<template>
    <content-header title="Income Report" icon="fa fa-angle-double-right"/>
    <content>
      <loading v-if="isTrue"/>
      <div v-else class="container-fluid">
        <div class="card">
  
  
  
          <!-- button action -->
          <div class="card-header pt-0">
            <div class="form-group w-sm-50 float-sm-left mb-0 mt-3">
                <select v-model="check_date" @change="clicker_date()" class="form-control selectPicker txt-kh" data-style="bg-system text-white">
                    <option value="">Select Range Date</option>
                    <option value="today">Today</option>
                    <option value="this_week">This Week</option>
                    <option value="this_month">This Month</option>
                    <option value="this_year">This Year</option>
                    <option value="last_week">Last Week</option>
                    <option value="last_two_week">Last two Week</option>
                    <option value="last_month">Last Month</option>
                    <option value="last_three_month">Last Three Month</option>
                    <option value="last_six_month">Last Six Month</option>
                    <option value="last_year">Last Year</option>
                </select>
            </div>
            
            
            <div class="form-group float-sm-right mb-0 mt-3">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="far fa-calendar-alt"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control float-right" id="reservation">
                    <div class="input-group-prepend" @click="clickRangeDate()">
                        <span class="input-group-text rounded-right border-left-0">
                            <i class="fa-solid fa-magnifying-glass"></i>
                        </span>
                    </div>
                </div>
            </div>
          </div>
  
  
  
          <div class="card-body">
            <div class="row my-3 mx-0">
                <div v-if="table.data.companies" class="col-lg-8 col-sm-8 d-sm-block d-none d-flex justify-content-center align-content-center">
                    <div class="row" style="box-sizing: border-box;">
                        <div class="col-lg-2 col-sm-12 mr-lg-3 mb-3 display-phone">
                            <img v-if="table.data.companies.logo" :src="resource + table.data.companies.logo" width="100" class="rounded-circle">
                        </div>
                        <div class="col-lg-8 col-sm-12 display-phone">
                            <span class="kh_muol p-0 d-block"> {{ table.data.companies.kh_name }}</span>
                            <span class="kh_content p-0 d-block"> {{ table.data.companies.en_name }}</span>
                            <span class="kh_content p-0 d-block">Address ៖ {{ table.data.companies.address }}</span>
                            <span class="kh_content p-0">Telephone ៖ {{ table.data.companies.phone_line1 }}</span>
                            <span v-if="table.data.companies.phone_line2"  class="kh_content p-0 ">, {{ table.data.companies.phone_line2 }}</span>
                            <span v-if="table.data.companies.phone_line3"  class="kh_content p-0 ">, {{ table.data.companies.phone_line3 }}</span>
                            <span v-if="table.data.companies.phone_line4"  class="kh_content p-0 ">, {{ table.data.companies.phone_line4 }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="table.data.companies" class="col-lg-4 col-sm-4 p-0">
                    <table width="100%" class="table-detail">
                        <tbody>
                            <tr class="border-bot">
                                <td class="text-left kh_muol" colspan="3">
                                    <h4>Sale Report</h4>
                                </td>
                            </tr>
                            <tr class="border-bot">
                                <td class="khos text-left">From Date</td>
                                <td class="text-right">:</td>
                                <td class="text-right">{{ new Date(table.data.from).toLocaleDateString("en-GB", { day : 'numeric', 'month' : 'numeric' , 'year' : 'numeric' }) }}</td>
                            </tr>
                            <tr class="border-bot">
                                <td class="khos text-left">To Date</td>
                                <td class="text-right">:</td>
                                <td class="text-right">{{ new Date(table.data.to).toLocaleDateString("en-GB", { day : 'numeric', 'month' : 'numeric' , 'year' : 'numeric' }) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
  
  
            <!-- table  -->
            <div  class="table-responsive-sm position-relative">
                <table v-if="table.data.data.length != 0" class="table data-table table-sm table-bordered" style="width: 100%">
                    <tr :id="`tr${table.data.length}table`">
                        <td colspan="2" data-col="=Summary" class="text-center text-md bg-dark text-md text-bold text-white">SUMMARY</td>
                    </tr>
                    <tr :id="`tr${table.data.length}table`">
                        <td class="d-none"></td>
                        <td data-col="#" class="text-center text-md"> {{ $t("total_price") }}
                            <button :data-row = "`tr${table.data.length}table`" onclick="toggleRow(this)" class="clicker btn btn-xs bg-system text-white rounded-circle">
                            <i class="fas fa-plus-circle"></i>
                            </button>
                        </td>
                        <td data-col="Total Price" class="text-md"> $ {{ totalPrice }} </td>
                    </tr> 
                    <tr :id="`tr${table.data.length}table`">
                        <td class="d-none"></td>
                        <td data-col="#" class="text-center text-md">{{ $t("total_cost") }} 
                            <button :data-row = "`tr${table.data.length}table`" onclick="toggleRow(this)" class="clicker btn btn-xs bg-system text-white rounded-circle">
                            <i class="fas fa-plus-circle"></i>
                            </button>
                        </td>
                        <td data-col="Total Cost" class="text-md"> $ {{ totalCost }} </td>
                    </tr> 
                    <tr :id="`tr${table.data.length}table`">
                        <td class="d-none"></td>
                        <td data-col="#" class="text-center text-md"> {{ $t("total_profit") }} 
                            <button :data-row = "`tr${table.data.length}table`" onclick="toggleRow(this)" class="clicker btn btn-xs bg-system text-white rounded-circle">
                            <i class="fas fa-plus-circle"></i>
                            </button>
                        </td>
                        <td data-col="Total Profit" class="text-md"> $ {{ totalProfit }} </td>
                    </tr> 
              </table>
              <br>
              <table class="table data-table table-sm table-bordered" style="width: 100%">
                <thead class="bg-system text-light">
                    <tr>
                        <th colspan="9" class="bg-dark" style="letter-spacing: .1em; text-transform: uppercase !important;">
                            <h5 class="text-center text-md text-bold m-0">Details</h5>
                        </th>
                    </tr>
                  <tr>
                    <th class="d-none"></th>
                    <th class="d-none">#</th>
                    <th>Invoice No.</th>
                    <th>Product</th>
                    <th>QTY</th>
                    <th>cost</th>
                    <th>price</th>
                    <th>VAT</th>
                    <th>Discount</th>
                    <th>Total</th>
                    <th>Profit</th>
                  </tr>
                </thead>
                <tbody v-if="table.data.data.length != 0">
                  <template v-for="(data, index) in table.data.data" :key="index">
                    <tr :id="`tr${index}table`">
                      <td class="d-none"></td>
                      <td class="d-none">{{ index + 1}}</td>
                      <td :data-col="'Invoice No.'"> {{ data.code }}
                        <button :data-row = "`tr${index}table`" onclick="toggleRow(this)" class="clicker btn btn-xs bg-system text-white rounded-circle">
                          <i class="fas fa-plus-circle"></i>
                        </button>
                      </td>
                      <td data-col="Product">{{ data.product_name }}</td>
                      <td data-col="QTY">{{ data.qty }}</td>
                      <td data-col="Cost">$ {{ formatToCurrency(Number(data.original_price) * Number(data.qty),2)}}</td>
                      <td data-col="Price">$ {{ formatToCurrency(Number(data.sub_total) - Number(data.vat),2) }}</td>
                      <td data-col="Vat">$ {{ formatToCurrency(Number(data.vat),2)}}</td>
                      <td data-col="Discount">$ {{ formatToCurrency(data.total_discount,2) }}</td>
                      <td data-col="Total">$ {{ formatToCurrency(Number(data.total_price),2) }}</td>
                      <td data-col="Profit"> $ {{  (Number(data.total_price) - (Number(data.original_price) * Number(data.qty))).toFixed(2)  }}</td>
                    </tr> 
                  </template>  
                    <tr :id="`tr${table.data.length}table`">
                        <td class="d-none"></td>
                        <td class="d-none"></td>
                        <td colspan="2" data-col="#" class="bg-gray text-light text-right text-lg" style="letter-spacing: .1em; text-transform: uppercase !important;"> TOTAL
                            <button :data-row = "`tr${table.data.length}table`" onclick="toggleRow(this)" class="clicker btn btn-xs bg-system text-white rounded-circle">
                            <i class="fas fa-plus-circle"></i>
                            </button>
                        </td>
                        <td data-col="Total QTY" class="bg-gray text-light text-lg">  {{ totalQty }} </td>
                        <td data-col="Total Cost" class="bg-gray text-light text-lg"> $ {{ totalCost }} </td>
                        <td data-col="Total Price" class="bg-gray text-light text-lg">$ {{ totalPrice }}  </td>
                        <td data-col="Total Vat" class="bg-gray text-light text-lg"> $ {{ totalVat }} </td>
                        <td data-col="Total Discount" class="bg-gray text-light text-lg"> $ {{ totalDiscount }} </td>

                        <td data-col="Total" class="bg-gray text-light text-lg"> $ {{ total }} </td>
                        <td data-col="Total Profit" class="bg-gray text-light text-lg"> $ {{ totalProfit }} </td>

                    </tr> 
                </tbody>
              </table>
            </div>
  

            <!-- Processing loader  -->
            <div v-if="pageLoad" class="card position-absolute " style="z-index:10; left: 45%; top: 50%;">
                <div class="card-body">
                <span class="txt-system">Processing...</span>
                </div>
            </div>

            <!-- no data -->
            <div v-if="table.data.data.length == 0" class="card">
                <div class="card-body text-center">
                  <span class="txt-system">No Data...</span>
                </div>
            </div>
  
  
          </div>
        </div>
      </div>
    </content>
    <content-header/>
  </template>
  
  <script>
  import axios from 'axios'
  import { resource } from '@/networks/domain'
  import { income } from '@/networks/services/pos/reports/income.service'
  import { checkPermission } from '@/networks/services/helper/helper.js'
  import Loading from '@/components/loading/Loading'
  import { config } from '@/networks/config'
  
  
  
  export default {
    components: { 
      Loading,
    },
    data(){
      return {
        table : {
          data: [],
        },

        check_date : 'today',
        resource : resource,
        fromDate : '',
        toDate : '',
  
        permission_no: false,
        isTrue: true,
        pageLoad: false,
        create: false,
        deleteAll : false,
        edit: false,
        list: false,
      }
    },
    computed : {
        totalVat(){
            let data = this.table.data.data;
            let amount = 0;
            data.forEach(item => {
                amount += Number(item.vat);
            });

            return this.formatToCurrency(amount,2);
        },
        totalPrice(){
            let data = this.table.data.data;
            let amount = 0;
            data.forEach(item => {
                amount += (Number(item.sub_total) - Number(item.vat));
            });

            return this.formatToCurrency(amount,2);
        },
        totalQty(){
            let data = this.table.data.data;
            let amount = 0;
            data.forEach(item => {
                amount += Number(item.qty);
            });

            return amount;
        },
        totalDiscount(){
            let data = this.table.data.data;
            let amount = 0;
            data.forEach(item => {
                amount += Number(item.total_discount);
            });


            return this.formatToCurrency(amount,2);
        },
        totalCost(){
            let data = this.table.data.data;
            let amount = 0;
            data.forEach(item => {
                amount += (Number(item.original_price) * Number(item.qty));
            });


            return this.formatToCurrency(amount,2);
        },
        total(){
            let data = this.table.data.data;
            let amount = 0;
            data.forEach(item => {
                amount += Number(item.total_price);
            });


            return this.formatToCurrency(amount,2);
        },
        totalProfit(){
            let data = this.table.data.data;

            let profit = 0;
            data.forEach(item => {
                const cal = Number(item.total_price) - (Number(item.original_price) * Number(item.qty));
                profit +=  cal;
            });

            return this.formatToCurrency(profit,2);
        }
    },
    methods : {
        formatToCurrency(amount,fixed = 2){
            if(fixed > 0){
                let luy = 0;
                if(Number(amount) < 0){
                    luy = -Number(amount);
                } else {
                    luy = Number(amount);
                }
                return Number(luy).toFixed(fixed).replace(/\d(?=(\d{3})+\.)/g, '$&,'); 
            } else {
                let luy = (amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                let new_luy = luy.split(".");
                return new_luy[0]; 
            }
        },
        clicker_date(){
            $('#reservation').val('');
            this.fromDate = '';
            this.toDate = '';
            this.pageLoad = true;
            this.getData(false);
        },
        clickRangeDate(){
            this.check_date = '',
            this.fromDate = $('#reservation').data('daterangepicker').startDate.format("YYYY-MM-DD");
            this.toDate = $('#reservation').data('daterangepicker').endDate.format("YYYY-MM-DD");
            this.pageLoad = true;
            this.getData(false);
        },
        async reloadSelectOption(){
            await this.$nextTick();
            $('.selectPicker').selectpicker('refresh');
            $('.selectPicker').selectpicker();
        },
        async getData(id){
            if(localStorage.getItem('posUser')){
                config();
                axios
                    .get(`${income(this.check_date,this.fromDate,this.toDate)}`)
                    .then(response => {
                        if(response.data.status === 'success'){
                            if(!id){
                                this.pageLoad = false;
                            
                                //table
                                this.table.data = response.data; 

                                //permission
                                this.list = response.data.list;
                                this.create = response.data.create;
                                this.deleteAll = response.data.delete;
                                this.edit = response.data.edit;

                                this.isTrue = false;

                    
                            }
                        } else if(response.data.status === 401) {
                            alertify.set('notifier','position', 'top-right');
                            alertify.error(`${response.data.message}`);
                            localStorage.removeItem('posUser');
                            this.$router.push('/Unauthenticated');
                        } else if(response.data.status == "is_permission_no"){
                            this.permision_no = true;
                        }
                        else {
                            console.log('something wrong with api');
                        }
                    })
                    .then(()=>{
                        this.reloadSelectOption();
                        $('#reservation').daterangepicker({
                            autoUpdateInput: true,
                            locale: {
                                cancelLabel: 'Clear',
                                format: 'DD/MM/YYYY'
                            },
                        });      
                        $('#reservation').on('apply.daterangepicker', function(ev, picker) {
                            $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
                        });

                        $('#reservation').on('cancel.daterangepicker', function(ev, picker) {
                            $(this).val('');
                        });
                    })
                    .catch(error => {
                            console.log(error)
                        }
                    );
            } else {
                this.$router.push('/Unauthenticated')
            }
        },
    },
    created(){
        this.getData(false);
    },
    mounted(){
      
    }
  }
  </script>
  
  <style>
  
  </style>